// extracted by mini-css-extract-plugin
export default {"backButton":"UsersByTeam_backButton__2aAUG","teamName":"UsersByTeam_teamName__PJJbN"};